import { Button } from "../Button/Button";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

interface Props {
  setStep: (x: number) => void;
  handleChange: (e: any) => void;
  data: any;
  setErrors: (x: any) => void;
  errors: any;
}

export const JoinFormContactInfo = ({
  setStep,
  handleChange,
  data,
  setErrors,
  errors,
}: Props) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="join_demco_personal mt-2"
    >
      <div className="field">
        <input
          type="text"
          name="name"
          id="name"
          onChange={(e: any) => handleChange(e)}
          placeholder=" "
          value={data.name}
          style={{ borderColor: errors.includes("name") ? "red" : "#ccc" }}
        />
        <label htmlFor="name" className="login_email_label">
          Full Name
        </label>
      </div>
      <div className="field">
        <input
          type="text"
          name="phone"
          id="phone"
          onChange={(e: any) => handleChange(e)}
          placeholder=" "
          value={data.phone}
          style={{ borderColor: errors.includes("phone") ? "red" : "#ccc" }}
        />
        <label htmlFor="phone" className="login_password_label">
          Phone Number
        </label>
      </div>
      <div className="field">
        <input
          type="email"
          name="email"
          id="email"
          onChange={(e: any) => handleChange(e)}
          placeholder=" "
          value={data.email}
          style={{ borderColor: errors.includes("email") ? "red" : "#ccc" }}
        />
        <label htmlFor="email" className="login_email_label">
          Email Address
        </label>
      </div>
      <Button
        buttonClass="submit_button_white_full_width submit_button_white_full_width_login company_join_btn"
        innerButton="Next"
        onClick={(e: any) => {
          e.preventDefault();
          if (data.name && data.phone && data.email) {
            setStep(1);
            setErrors(
              errors.filter(
                (el: any) => el !== "name" && el !== "phone" && el !== "email"
              )
            );
          } else {
            let keys = ["name", "phone", "email"];
            setErrors(keys.filter((el: string) => !data[el]));
          }
        }}
        icon={<FontAwesomeIcon icon={faArrowRight} />}
      />
    </motion.div>
  );
};
